import { NotificationType } from '../../../models/notification.models';

export interface IAppLevelModalsData {
  notificationByAuthId: INotification[];
  pointsTransactionByAuthIdAndType: IPointsEdges;
  notificationsNCByAuthId: INotificationNc[];
}

export interface INotification {
  id: string;
  notificationType: NotificationType;
  activeOn: string;
  sourceObjectIds: string[];
  data: IData | null;
}

export interface IData {
  lockedUntil: string;
}

export interface IPointsEdges {
  edges: IPointsEdge[];
}

export interface IPointsEdge {
  node: IPointsNode;
}

export interface IPointsNode {
  points: number;
  transactionType: PointsTransactionType;
}

export enum PointsTransactionType {
  BIRTHDAY = 'BIRTHDAY',
}

export interface INotificationNc {
  id: string;
  data: string;
  type: NotificationType;
  acknowledged: boolean;
}
